<div class="auth-page">
  <div class="ambient-glow"></div>

  <div class="theme-toggle-btn" (click)="toggleTheme()" [title]="themeService.isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
    <span class="material-symbols-outlined">{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</span>
  </div>

  <div class="auth-container">
    <div class="auth-logo">
      <img src="assets/img/logo-icon.png" alt="Nectum" class="logo-img" />
      <span class="logo-text">Nectum Investment <sup class="logo-reg">®</sup></span>
    </div>

    <div class="auth-card text-center">
      <span class="material-symbols-outlined logout-icon">local_cafe</span>
      <h2 class="logout-title">¡Hasta pronto!</h2>
      <p class="logout-subtitle">Cerraste sesión correctamente.</p>
      <a routerLink="/login" class="submit-btn">Iniciar sesión</a>
    </div>
  </div>
</div>
